(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
/* Deep-link vers un motif : /pages/contact?sujet=remboursement (ou #remboursement).
   Purement additif — sans JS, le formulaire reste complet et le motif se choisit à la main. */
(function () {
  function applyDeepLink() {
    var select = document.getElementById('cf-subject');
    if (!select) return;

    var wanted = '';
    try {
      wanted = new URLSearchParams(window.location.search).get('sujet') || '';
    } catch (e) {
      wanted = '';
    }
    if (!wanted && window.location.hash) {
      wanted = window.location.hash.slice(1);
    }
    if (!wanted) return;

    /* On n'injecte dans le sélecteur que ce qui ressemble à une poignée connue :
       pas de CSS.escape à supposer présent, pas d'échappement à rater. */
    wanted = wanted.toLowerCase();
    if (!/^[a-z0-9-]+$/.test(wanted)) return;

    var option = select.querySelector('option[data-subject="' + wanted + '"]');
    if (!option) return;

    select.value = option.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));

    /* Le hash ne pointe sur aucun élément : c'est à nous d'amener le formulaire à l'écran. */
    select.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'center'
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDeepLink);
  } else {
    applyDeepLink();
  }

  window.addEventListener('hashchange', applyDeepLink);
})();

  } catch(e) { console.error(e); }
})();
})();
